import Vue from 'vue'
import App from './views/App'
import router from './router'
import store from './store'
import resource from 'vue-resource'
import CKEditor from 'ckeditor4-vue'
import './filters'
import './directives'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import './helpers/middleware'
import './assets/matrix.css'
import Datetime from 'vue-datetime-24period'
import 'vue-datetime/dist/vue-datetime.css'

import Utils from './utils/utils'

Vue.config.productionTip = false
Vue.use(Datetime);
Vue.use(resource)
Vue.use(CKEditor);
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_SITEKEY })
Vue.http.options.root = (process.env.NODE_ENV == 'production' ? '/admin' : '') + '';
Vue.http.interceptors.push((request, next) => {
  request.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
  next(response => {
    switch (response.status) {
      case 401:
      case 403: router.push('/403'); break;
    }
  })
})

new Vue({
  store,
  router,
  data: {
    title: null,
    subTitle: null,
    pages: []
  },
  render: h => h(App),
  async mounted() {
    await this.$store.dispatch('getConfigData')
    this.$router.beforeResolve(async (to, _, next) => {
      if (to.meta.allowAnonymous === true) {console.log('1');return next()}
      if (!localStorage.getItem('token')) {console.log('2');return next('/login')}
      if (new Date() - new Date(localStorage.getItem("token.time")) >= 1200000) {console.log('3');return next('/login')}
      if (to.meta.noPermission) {console.log('4');await Utils.getDataFirstLogin() ;return next()} //登入成功或已登入或keycloak登入   首頁進入點
      await this.functions(); console.log('5')
      if (!this.pages.map(a => a.url).includes(to.name)) {console.log('6');return next('/403')}
      console.log('7')
      await Utils.getDataFirstLogin() // 已登入 其他頁面進入點
      next()
    })
    
  },
  methods: {
    async functions(reset) {
      if (reset) this.result = null;
      if (this.result) return this.result;
      this.result = await this.$http.get('/api/my/functions');
      let
        pages = [],
        apis = [],
        operations = [];
      (function x(a) {
        if (!a) return;
        a.forEach(b => {
          switch (b.type) {
            case 'page': pages.push(b); break;
            case 'api': apis.push(b); break;
            case 'operation': operations.push(b); break;
          }
          x(b.children);
        });
      })(this.result.body);
      this.pages = pages;
      this.apis = apis;
      this.operations = operations;
      return this.result;
    }
  }
}).$mount('#app')
